import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, Platform, ToastController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';
import { BarcodeScannerOptions} from '@ionic-native/barcode-scanner';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { QRScanner, QRScannerStatus } from '@ionic-native/qr-scanner';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'page-cow-register',
  templateUrl: 'cow_register.html'
})
export class CowRegister {
  options: BarcodeScannerOptions
  encodText:string='';
  encodedData:any={};
  scannedData:any={};
  userImg: any = '';
  public base64Img: string = '';
  gelleryOptions: CameraOptions = {
    quality: 100,
    sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    destinationType: this.camera.DestinationType.DATA_URL,
    allowEdit: true
  }
  cameraOptions: CameraOptions = {
    quality: 100,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    allowEdit: true
   }
  // Array
  public CowTypesArray = [];
  public CowStatusesArray = [];
  public CowGenderArray = [];
  public COWS = [];
  public BullArray = [];
  public MotherArray = [];
  public res2

  // NavParams
  public cow_id: any;
  public cow_code: string;
  public button: string;

  // Form elements
  public farm: any;
  public Cow_Code;
  public Mother_Code: any;
  public Father_Code: any;
  public Cow_Name: string;
  public Sex: any;
  public Cow_Type: any;
  public Cow_Status: any;
  public Cow_Image: string = "";
  public Birth_Date: String = new Date().toISOString();
  public date;
  public loader;
  public Status_Start_Date: String = new Date().toISOString();
   public Sim_Status_ID;
   public simMasterTable = [];

  constructor(
    public navCtrl: NavController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    navParams: NavParams,
    private camera: Camera,
    private loadingCtrl:LoadingController,
    private qrScanner: QRScanner,
    protected datepipe: DatePipe,
    public plt: Platform
    ) {
    let id = navParams.get('cow_id');
    let cow_qr = navParams.get('cow_code');
    this.cow_id = id;
    this.cow_code = cow_qr;
    this.userImg = 'assets/imgs/avatar.png';
  }
  ionViewDidLoad() {
        this.showLoader();
        this.CowGenderArray = JSON.parse(localStorage.getItem('CowGenderArray'));
        this.CowTypesArray = JSON.parse(localStorage.getItem('CowTypesArray'));
        this.CowStatusesArray = JSON.parse(localStorage.getItem('CowStatusesArray'));
        this.BullArray = JSON.parse(localStorage.getItem('BullArray'));
        this.MotherArray = JSON.parse(localStorage.getItem('MotherArray'));
        this.hideLoader();
  }
  
  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    
    window.BASE64_RESULT = '';
    if(this.cow_id != null){
      this.data.currentTabName = 'Бүртгэл шинэчлэх';
      this.button = 'Шинэчлэх';
    }else{
      this.data.currentTabName = 'Үхэр бүртгэх';
      this.button = 'Хадгалах';
      this.Sex = '1';
      this.Cow_Type = '1';
      this.Cow_Status = '1';
    }
    if(this.cow_id){
      this.rest.UpdateCowsGet(
        this.cow_id
      ).subscribe(res =>{
        console.log(res);
        this.COWS = res;
        this.Cow_Code = this.cow_code;
        this.Mother_Code = this.COWS[0]["cow_mother_id"];
        this.Father_Code = this.COWS[0]["cow_father_id"];
        this.Cow_Name = this.COWS[0]["cow_name"];
        this.Birth_Date = this.COWS[0]["birth_date"];
        this.Status_Start_Date = this.COWS[0]["status_start_date"];
        this.Cow_Image = this.COWS[0]["cow_image"];
        this.Sex = this.COWS[0]["sex"];
        
        var master = JSON.parse(localStorage.getItem('simMasterTable'));
          for(let i = 0; i < master.length; i++) {
            if (this.Sex == 2 && master[i].type == 0) {
              this.simMasterTable.push(master[i]);
              
            } else if(this.Sex != 2 && master[i].type == 1) {
              this.simMasterTable.push(master[i]);
            }
          }
        this.Cow_Type = this.COWS[0]["cow_type"];
        this.Cow_Status = this.COWS[0]["cow_status"];
        this.Sim_Status_ID = this.COWS[0]["sim_status_id"];
      })
    } else {
      // this.simMasterTable = JSON.parse(localStorage.getItem('simMasterTable'));
      var master = JSON.parse(localStorage.getItem('simMasterTable'));
      for(let i = 0; i < master.length; i++) {
        if (this.Sex == 2 && master[i].type == 0) {
          this.simMasterTable.push(master[i]);
          
        } else if(this.Sex != 2 && master[i].type == 1) {
          this.simMasterTable.push(master[i]);
        }
      }
    }
  }

  MasterDataFilter(Sex) {
    console.log(Sex);
    this.simMasterTable = [];
    var master = JSON.parse(localStorage.getItem('simMasterTable'));
    for(let i = 0; i < master.length; i++) {
      if (Sex == 2 && master[i].type == 0) {
        this.simMasterTable.push(master[i]);
      } else if(Sex != 2 && master[i].type == 1) {
        this.simMasterTable.push(master[i]);
      }
    }
    console.log(this.simMasterTable);
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showLoader(content?: string) {
    if (this.loader) {
      this.loader.dismiss();
    }
    this.loader = this.loadingCtrl.create({ 
      content: content ? content : "Ачаалж байна..."
    })
    this.loader.present();
    this.loader.onDidDismiss(()=>{
      this.loader = null;
    })
  }
  hideLoader() {
      if(this.loader)
        this.loader.dismiss();
  }
  
  openCamera() {
    this.camera.getPicture(this.cameraOptions).then((imgData) => {
      console.log('image data =>  ', imgData);
      this.userImg = 'data:image/jpeg;base64,' + imgData;
      this.base64Img = imgData;
      window.BASE64_RESULT = '';
    }, (err) => {
      console.log(err);
    })
  }
  openGallery() {
    if(this.plt.is('android') || this.plt.is('ios')){
        this.camera.getPicture(this.gelleryOptions).then((imgData) => {
        console.log('image data =>  ', imgData);
        this.userImg = 'data:image/jpeg;base64,' + imgData;
        this.base64Img = imgData;
        window.BASE64_RESULT = '';
      }, (err) => {
        console.log(err);
      })
    } else {
      const input: HTMLElement = document.getElementById('onFileSelect');
      input.click();
    }
  }
  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        window.BASE64_RESULT = reader.result.toString();
        console.log(window.BASE64_RESULT);
      };
    }
  }
  preview = (show: boolean): void => {
    if (show) {
      (window.document.querySelector("ion-app") as HTMLElement).classList.add("cameraView");
      window.document.body.style.backgroundColor = "transparent";
      document.getElementById('qrreader').style.display = 'none';
    } else {
      (window.document.querySelector("ion-app") as HTMLElement).classList.remove("cameraView");
      window.document.body.style.backgroundColor = '#FFF';
      document.getElementById('qrreader').style.display = 'block';
    }
  }

  qrread() {
    this.qrScanner.prepare()
    .then((status: QRScannerStatus) => {
      if (status.authorized) {
        this.preview(true);
        // camera permission was granted
        // start scanning
        let scanSub = this.qrScanner.scan().subscribe((text: any) => {
          console.log('Scanned something', text);
          this.Cow_Code = text.result;
          this.preview(false);
          this.qrScanner.hide(); // hide camera preview
          scanSub.unsubscribe(); // stop scanning
        });

      } else if (status.denied) {
        // camera permission was permanently denied
        // you must use QRScanner.openSettings() method to guide the user to the settings page
        // then they can grant the permission from there
        this.showToast('Та камераа ашиглахыг зөвшөөрнө үү!');
      } else {
        // permission was denied, but not permanently. You can ask for permission again at a later time.
        this.showToast('Та камераа ашиглахыг зөвшөөрнө үү!');
      }
    })
    .catch((e: any) => {
      console.log('Error is', e);
      this.showToast('Та камераа ашиглахыг зөвшөөрнө үү!' + e);
    });
  }

  
  scanSub: any;
  QRSCAN(){
    this.qrScanner.prepare().
    then((status: QRScannerStatus) => {
      if (status.authorized) {
        this.qrScanner.show();
        this.scanSub = document.getElementsByTagName('body')[0].style.opacity = '0';
        debugger
        this.scanSub = this.qrScanner.scan()
          .subscribe((textFound: string) => {
            document.getElementsByTagName('body')[0].style.opacity = '1';
            this.qrScanner.hide();
            this.scanSub.unsubscribe();
            this.showLoader();
            this.Cow_Code = textFound;
            this.hideLoader();
          }, (err) => {
            alert(JSON.stringify(err));
          });

      } else if (status.denied) {
      } else {

      }
    })
    .catch((e: any) => console.log('Error is', e));
  }
  
  Update(){
    this.date = this.Birth_Date;
    this.rest.UpdateCows(
        this.cow_id,
        this.data.farm_id, 
        this.Cow_Code, 
        this.Cow_Name, 
        this.date, 
        this.Sex, 
        this.Cow_Type, 
        this.Cow_Status,
        this.Cow_Image,
        this.Sim_Status_ID,
        this.Status_Start_Date.toString()).subscribe(res => {
          if(res.result == true){
            this.showToast('Амжилттай шинэчиллээ.');
            this.rest.Cows(localStorage.getItem('farmId')).subscribe(res => {
              localStorage.setItem('Cows', JSON.stringify(res));
              }
            )
            this.hideLoader();
          }else if(res.result == false){
            this.showToast1('Алдаа гарлаа.');
            this.hideLoader();
          }
      }
    );
  }
  Insert() {
    this.date = this.Birth_Date;
    this.rest.Base64ToFile(this.Cow_Code, this.base64Img).subscribe(
      (res) => {
        this.hideLoader();
        console.log(res.url);
        this.Cow_Image = res.url;
        this.base64Img = '';
        this.rest.InsertCow(
          this.data.farm_id, 
          this.Cow_Code,
          this.Mother_Code, 
          this.Father_Code, 
          this.Cow_Name, 
          this.date, 
          this.Sex, 
          this.Cow_Type, 
          this.Cow_Status,
          this.Cow_Image,
          this.Sim_Status_ID,
          this.Status_Start_Date.toString()).subscribe(res => {
            if(res.result == true){
              let Cow_Weight: Array<number>;
              let Cow_Temperature: Array<number>;
              let Cow_Height: Array<number>;
              Cow_Weight = [100,200,150,180,200,150,160,170,180,190,200,140]
              Cow_Temperature = [37,38,39,40,41,38,38,39,37,34,35,36]
              Cow_Height = [100,110,112,113,114,115,116,120,130,140,121,140]
              var myCurrentDate=new Date();
              var myPastDate=new Date(myCurrentDate);
              myPastDate.setDate(myPastDate.getDate() - 77);
              var array = [];
              for( let i = 0; i <= 10; i++){
                array.push(myPastDate.setDate(myPastDate.getDate() + 7));
                console.log(myPastDate);
                this.rest.InsertWeight(
                  this.data.userId,
                  this.Cow_Code,
                  this.datepipe.transform(myPastDate, 'yyyy-MM-dd HH:mm:ss'),
                  Cow_Weight[i],
                  Cow_Temperature[i],
                  Cow_Height[i]
                  ).subscribe(res => {
                    console.log(res);
                },
                err=>{
                  console.log(err);
                })
              }
              this.rest.Cows(localStorage.getItem('farmId')).subscribe(res => {
                localStorage.setItem('Cows', JSON.stringify(res));
                }
              )
              this.hideLoader();
              this.showToast('Амжилттай хадгаллаа.');
              this.Mother_Code = '';
              this.Father_Code = '';
              this.Cow_Code = '';
              this.Cow_Name = '';
              this.Sex = '1';
              this.Cow_Type = '1';
              this.Cow_Status = '1';
            }else if(res.result == false){
              this.showToast1('Алдаа гарлаа.');
              this.hideLoader();
            }
          },
          (err) => {
            console.log('Cow register error')
            this.hideLoader();
          }
        );
        
      },
      (err) => {
        this.showToast1('Алдаа гарлаа.');
        this.hideLoader();
        this.Cow_Image = '';
        this.base64Img = '';
        console.log(err);
        this.hideLoader();
      }
    );
  }
  Save(){
    console.log(window.BASE64_RESULT);
      if(this.plt.is('core') && window.BASE64_RESULT != '') {
        this.userImg = window.BASE64_RESULT;
        var imgData = window.BASE64_RESULT.split(';base64,');
        this.base64Img = imgData[1];
      }
      // update hiih
      if(this.cow_id != null){
        if(this.base64Img != ''){
          this.rest.Base64ToFile(this.Cow_Code, this.base64Img).subscribe(
            (res) => {
              this.hideLoader();
              console.log(res.url);
              this.Cow_Image = res.url;
              this.base64Img = '';
              if (!this.Validation()) {
                return true;
              } else {
                this.Update();
              }
            },
            (err) => {
              this.showToast1('Алдаа гарлаа.');
              this.Cow_Image = '';
              this.base64Img = '';
              console.log(err);
              this.hideLoader();
            }
          );
        } else {
          if (!this.Validation()) {
            return true;
          } else {
            this.Update();
          }
          this.hideLoader();
        }
      } else {
        if (!this.Validation()) {
          return true;
        } else {
          this.Insert();
        }
      }
    }
    Validation() {
      let err = false;
      if (this.Cow_Code == null || this.Cow_Code == '') {
        err = true;
        this.showToast1('Та qr уншуулна уу!');
      }
      if (this.Cow_Name == null || this.Cow_Name == '') {
        err = true;
        this.showToast1('Та үхрийн нэр оруулна уу!');
      }
      if (this.Cow_Status == null || this.Cow_Status == '') {
        err = true;
        this.showToast1('Та үхрийн статус оруулна уу!');
      }
      if (this.cow_code == null || this.cow_code == '') {
        if (this.base64Img == null || this.base64Img == '') {
          err = true;
          this.showToast1('Та зураг оруулна уу!');
        }
      }
      if (err) {
        return false;
      }
      return true;
    }
}
declare global {
  interface Window {
    BASE64_RESULT?: string;
  }
}



// WEBPACK FOOTER //
// ./src/pages/cow_register/cow_register.ts